module.exports = __webpack_public_path__ + "img/attack-fire_archers.4df52869.png";